import { useState } from 'react'
import { Plus } from 'lucide-react'
import { Toggle, Field, Input } from '../components/ui'
import { useSettings } from '../lib/settings'
import { CAT_COLORS, CATEGORY_EMOJIS } from '../lib/constants'

export default function SettingsPage() {
  const { showHomeTotals, setShowHomeTotals, showRoomTotals, setShowRoomTotals, categories, toggleCategory, addCategory, deleteCategory } = useSettings()
  const [newName, setNewName] = useState('')
  const [newEmoji, setNewEmoji] = useState('🏷️')
  const activeCount = categories.filter(c => c.active).length

  const handleAdd = () => {
    const name = newName.trim()
    if (!name) return
    const key = name.charAt(0).toUpperCase() + name.slice(1)
    if (categories.find(c => c.key.toLowerCase() === key.toLowerCase())) return
    addCategory({
      key, emoji: newEmoji, active: true, custom: true,
      color: CAT_COLORS[categories.length % CAT_COLORS.length]
    })
    setNewName(''); setNewEmoji('🏷️')
  }

  return (
    <div className="page-body">
      <div className="page-header">
        <div className="page-header-left">
          <h1 className="page-title">Settings</h1>
          <p className="page-subtitle">Customize how the app looks and works</p>
        </div>
      </div>

      {/* Spend totals */}
      <div className="settings-card">
        <div className="settings-card-title">Display — Spend Totals</div>
        <div className="toggle-row">
          <div>
            <div className="toggle-label">Show total spend on property cards</div>
            <div className="toggle-desc">Displays committed spend on the property list</div>
          </div>
          <Toggle checked={showHomeTotals} onChange={setShowHomeTotals} />
        </div>
        <div className="toggle-row">
          <div>
            <div className="toggle-label">Show total spend on room cards</div>
            <div className="toggle-desc">Displays item totals inside each room view</div>
          </div>
          <Toggle checked={showRoomTotals} onChange={setShowRoomTotals} />
        </div>
      </div>

      {/* Categories */}
      <div className="settings-card">
        <div className="settings-card-title">Item Categories</div>
        <div style={{ paddingTop: 4 }}>
          {categories.map(cat => (
            <div key={cat.key} className="cat-row">
              <div className="cat-left">
                <span style={{ fontSize: 18, width: 26, textAlign: 'center', flexShrink: 0 }}>{cat.emoji}</span>
                <span className="cat-name">{cat.key}</span>
                {cat.custom && <span className="cat-custom-badge">custom</span>}
                {activeCount === 1 && cat.active && <span style={{ fontSize: '.68rem', color: 'var(--ocean)', fontStyle: 'italic', marginLeft: 6 }}>min 1</span>}
              </div>
              <div className="cat-right">
                {cat.custom && (
                  <button className="btn btn-danger btn-sm" onClick={() => deleteCategory(cat.key)}>
                    Remove
                  </button>
                )}
                <Toggle checked={cat.active} onChange={val => toggleCategory(cat.key, val)} />
              </div>
            </div>
          ))}
        </div>

        {/* Add custom category */}
        <div style={{ borderTop: '1px solid var(--border)', padding: '16px 0 8px' }}>
          <div style={{ fontSize: '.75rem', fontWeight: 500, color: 'var(--text-secondary)', marginBottom: 10 }}>Add custom category</div>
          <div className="emoji-grid">
            {CATEGORY_EMOJIS.map(e => (
              <button key={e} className={`emoji-btn${newEmoji === e ? ' selected' : ''}`} onClick={() => setNewEmoji(e)}>{e}</button>
            ))}
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, paddingTop: 8, paddingBottom: 4 }}>
            <span style={{ fontSize: 20, width: 26, textAlign: 'center', flexShrink: 0 }}>{newEmoji}</span>
            <input
              className="form-input"
              placeholder="Category name…"
              style={{ flex: 1 }}
              value={newName}
              onChange={e => setNewName(e.target.value)}
              onKeyDown={e => e.key === 'Enter' && handleAdd()}
            />
            <button className="btn btn-primary btn-sm" onClick={handleAdd}>
              <Plus size={13} /> Add
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
